<template>
  <div id="notice">
    <v-container fluid grid-list-md class="container-wrapper">
      <div class="title-wrapper">
        <h1 class="font-face">Hear Ye... Hear Ye</h1>
      </div>
      <v-layout column wrap align-center justify-center class="notice-layout">
        <hr class="hr-notice">
            <div class="notice-cont-wrapper font-face">Pick up our mead, ales, ciders in the heart of Tameworpig.... <br>The <a href="https://www.facebook.com/tamworthbrewingco/" target="_blank">Tamworth Tap</a>
            </div>
            <hr class="hr-notice">
            <div column class="notice-cont-wrapper font-face"><span>The following encampments are scheduled to take place :</span>
            <v-flex row>
              <br>

              <div class="notice-cont"><img class="shield" src="../../assets/images/shield.png" alt=""><a href="https://www.battleofevesham.co.uk/MedievalMarket.html" target="_blank" alt="battleofevesham medievalmarket">Evesham Medieval Market 22th/23th May</a></div>
              <div class="notice-cont"><img class="shield" src="../../assets/images/shield.png" alt="">History alive at Stonham Barns 26th/27th June</div>
              <div class="notice-cont"><img class="shield" src="../../assets/images/shield.png" alt="">Colchester Medieval Fayre 31st of July/1st of August</div>
              <div class="notice-cont"><img class="shield" src="../../assets/images/shield.png" alt="">Battle of Evesham 7th/8th of August</div>
              <div class="notice-cont"><img class="shield" src="../../assets/images/shield.png" alt="">Hever Castle 28th/30th of August</div>
              <div class="notice-cont"><img class="shield" src="../../assets/images/shield.png" alt="">Festival of Pagans and Witches at Heart of England Conference Center 18th/19th of September</div>


            </v-flex>

            </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Blog from './_subs/Blog.vue'

export default {
  name: 'Outside',
  props: {
  },
  components: {
    Blog
  }
}
</script>

<style scoped lang="scss">
@import '../../styles/GlobalStyles.scss';

@font-face {
  font-family: 'Algerian';
  src: url('../../assets/fonts/Algerian-Regular.ttf') format('truetype');
}
#notice {
  background-color:black;
  color: black;
  padding: 30px;
  display: flex;
}
@media only screen and (max-width: $phone) {
  #notice {
    padding: 0px;
    
  }
}
.shield{
  width: 24px;
  margin-right: 5px;
}
.notice-cont {
  font-size: 18px;
    align-items: center;
    align-content: center;
    display: flex;
    text-align:left;
    padding-bottom: 10px;
}
.title-wrapper {
  margin-bottom: 20px;
  text-align:center;
  color:black;
}
.notice-cont-wrapper {
     max-width: 1200px;
    position: relative;
    padding: 40px 30px;
    margin: 10px;
    position: relative;
    text-align: center;
    font-size:20px;
}
@media only screen and (max-width: $phone) {
.notice-cont-wrapper {
    padding: 40px 0px;
    margin: 0px;
    font-size:15px;
}
}
#notice .container-wrapper {
     border-style: double;
    margin: auto;
    max-width: 900px;
      background-size: cover;
  background-image: url("./../../assets/images/label_smaller.jpeg");
  width: contain;
  .notice-layout .hr-notice {
    border: 1px solid rgba(0,0,0,0.7);
    margin: 0;
    padding: 0;
    width:100%;
    max-width: 500px;
    margin: auto;
  }
.notice-cont a {
  text-decoration: none;
  color:black;
  cursor:pointer;
}
.notice-cont a:hover {
  color:rgb(78, 57, 57);
}
}


</style>
